import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { EnvironmentService } from "../../../../environments/service/environment.service";
import { Appointment } from "../../model/v2/appointment/appointment";
import { AppointmentStatus } from "../../model/v2/appointment/appointment-status";
import { AppointmentTime } from "../../model/v2/appointment/appointment-time";
import {
  AssignedFormList,
  AssignFormToAppointment,
  saveAssidnFormWithAppointment,
} from "../../model/v2/appointment/assigned-form-list";
import { CreateAppointment } from "../../model/v2/appointment/create-appointment";
import { ProviderCostEstimator } from "../../model/v2/appointment/provider-cost-estimator";
import { RescheduleAppointmnet } from "../../model/v2/appointment/reschedule-appointment";
import { BaseService } from "../shared/base.service";

@Injectable({
  providedIn: "root",
})
export class AppointmentsService {
  constructor(private baseService: BaseService,
    private env: EnvironmentService) { }

  getAppointments(
    practitionerId: number,
    healthSystemId: number
  ): Observable<Appointment[]> {
    const criteria = {
      practitionerId: practitionerId,
      healthSystemId: healthSystemId,
    };
    return this.baseService.post<any>(
      `AppointmentContoller/GetAppointmentsBySearchCriteria`,
      criteria
    );
  }

  updateAppointmentStatus(appointment: any): Observable<any> {
    return this.baseService.post<any>(
      `AppointmentContoller/UpdateAppointmentStatus`,
      appointment
    );
  }

  rescheduleAppointment(appointment: RescheduleAppointmnet): Observable<any> {
    return this.baseService.post<any>(
      `AppointmentContoller/RescheduleAppointment`,
      appointment
    );
  }

  updateAppointmentTime(appointmentTime: AppointmentTime): Observable<any> {
    return this.baseService.patch<any>(
      `AppointmentContoller/UpdateAppointmentTime`,
      appointmentTime
    );
  }

  assignAppointmentSlots(appointmentSlots: any): Observable<any> {
    return this.baseService.post<any>(
      `AppointmentContoller/AssignAppointmentSlots`,
      appointmentSlots
    );
  }

  createAppointment(appointment: CreateAppointment): Observable<any> {
    return this.baseService.post<any>(
      `AppointmentContoller/CreateAppointment`,
      appointment
    );
  }

  updateAppointment(appointment: CreateAppointment): Observable<any> {
    return this.baseService.put<any>(
      `AppointmentContoller/UpdateAppointmentDetails`,
      appointment
    );
  }

  getAppointmentsByPatientId(patientId: number): Observable<any> {
    return this.baseService.get<any>(
      `AppointmentContoller/GetAppointmentsByPatientId?patientId=${patientId}`
    );
  }

  getAppointmentsBySearchCriteria(criteria: any): Observable<any> {
    return this.baseService.post<any>(`AppointmentContoller/GetAppointmentsBySearchCriteria`, criteria);
  }

  GetFreeAppointmentAllottedSlots(practitionerId: number, HealthSystemId: number, AppointmentDate: string, Period: string): Observable<any> {
    return this.baseService.get<any>(
      `AppointmentContoller/GetFreeAppointmentAllottedSlots?PractitionerId=${practitionerId}&HealthSystemId=${HealthSystemId}&AppointmentDate=${AppointmentDate}&Period=${Period}`
    );
  }

  getFormsByAppointment(appointmentId: number): Observable<AssignedFormList[]> {
    return this.baseService.get<AssignedFormList[]>(
      `AppointmentContoller/GetFormsByAppointment?appointmentId=${appointmentId}`
    );
  }

  assignFormToAppointment(
    assignForm: saveAssidnFormWithAppointment
  ): Observable<any> {
    return this.baseService.post<any>(
      `AppointmentContoller/AssignFormToAppointment`,
      assignForm
    );
  }

  getProviderCostEstimation(providerCostEstimatorRequestObj: ProviderCostEstimator): Observable<any> {
    return this.baseService.postWithApiEndpoint<any>(
      this.env.handleHealthUrl,
      providerCostEstimatorRequestObj,
      this.env.handleHealthKey
    );
  }

  getAppointmentById(appointmentId: number): Observable<any> {
    return this.baseService.get<any>(
      `AppointmentContoller/GetAppointmentById?appointmentId=${appointmentId}`
    );
  }

}
